import { MAP_TYPE_KEY } from '@kartothek/shared';
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { MapView } from '../components/MapView';
import { useCampaign, useNote } from '../hooks';
import { t } from '../i18n';

/** Karte im Vollbild (für die Session am Tisch). */
export function MapPage() {
  const { cid = '', nid = '' } = useParams();
  const note = useNote(cid, nid);
  const campaign = useCampaign(cid);
  useEffect(() => {
    if (note.data) document.title = `${note.data.title} · Kartothek`;
  }, [note.data]);
  if (note.isLoading) return <div className="muted pad">{t('common.loading')}</div>;
  if (!note.data) return <div className="pad error">{t('common.error')}</div>;
  if (note.data.typeKey !== MAP_TYPE_KEY) return <Navigate to={`/c/${cid}/n/${nid}`} replace />;
  return <MapView note={note.data} gm={!!campaign.data && campaign.data.role !== 'player'} fullscreen />;
}
